export default __webpack_public_path__ + "static/media/building-wall-color-set-off.6a16c058.svg";